export default "<span class=\"example-pizza-party\">\r\n    Pizza party!!! 🍕\r\n</span>"